import React from 'react';
import Modal from 'react-modal';
import styles from './CustomModal.module.css';

const CustomModal = ({
                         isOpen,
                         onRequestClose,
                         message,
                         isPositiveMessage,
                         confirmLabel,
                         onConfirm,
                         confirmButtonColor,
                         cancelLabel,
                         onCancel,
                         cancelButtonColor,
                     }) => {
    const modalStyle = {
        content: {
            backgroundColor: isPositiveMessage ? 'lightgreen' : 'lightcoral',
        },
        overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
        },
    };

    const renderMessage = () => {
        if (typeof message === 'object') {
            return (
                <ul>
                    {Object.entries(message).map(([key, value]) => (
                        <li key={key}>{value}</li>
                    ))}
                </ul>
            );
        }
        return <p className={styles.modalMessage}>{message}</p>;
    };

    const confirmButtonStyle = confirmButtonColor
        ? { backgroundColor: confirmButtonColor }
        : {};

    const cancelButtonStyle = cancelButtonColor
        ? { backgroundColor: cancelButtonColor }
        : {};


    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            style={modalStyle}
            contentLabel="Example Modal"
            className={styles.modalContent}
            overlayClassName={styles.modalOverlay}
        >
            {renderMessage()}
            {onConfirm && (
                <button
                    onClick={onConfirm}
                    className={`${styles.modalButton} ${
                        isPositiveMessage ? styles.buttonPositive : styles.buttonNegative
                    }`}
                    style={confirmButtonStyle}
                >
                    {confirmLabel}
                </button>
            )}
            <button
                onClick={onCancel || onRequestClose}
                className={`${styles.modalButton} ${
                    isPositiveMessage ? styles.buttonPositive : styles.buttonNegative
                }`}
                style={cancelButtonStyle}
            >
                {cancelLabel}
            </button>
        </Modal>
    );
};

export default CustomModal;
